import breakpoint from '../scripts/breakpoint';
import $ from 'jquery';

$.addInit(function(context){
	var base = '.b-routes';
	$(base, context).each(function(){
		var component = $(this);

		var address = component.find('.b-tagsInfo-link');
		var addressActive = component.find('.b-tagsInfo-link.m-active');

		if (!google.maps) {
			console.warn('google maps not defined');
			return;
		}

		function getCookie(e) {
			var t = document.cookie.match(new RegExp("(?:^|; )" + e.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"));
			return t ? decodeURIComponent(t[1]) : void 0
		}

		function setCookie(e, t, o) {
			o = o || {};
			var a = o.expires;
			if ("number" == typeof a && a) {
				var n = new Date;
				n.setTime(n.getTime() + 1e3 * a),
					a = o.expires = n
			}
			a && a.toUTCString && (o.expires = a.toUTCString()),
				t = encodeURIComponent(t);
			var s = e + "=" + t;
			for (var i in o) {
				s += "; " + i;
				var r = o[i];
				r !== !0 && (s += "=" + r)
			}
			document.cookie = s
		}

		function deleteCookie(e) {
			setCookie(e, "", {
				expires: -1
			})
		}

		function InfoBox(opt_opts) { opt_opts = opt_opts || {}; google.maps.OverlayView.apply(this, arguments); this.content_ = opt_opts.content || ""; this.disableAutoPan_ = opt_opts.disableAutoPan || false; this.maxWidth_ = opt_opts.maxWidth || 0; this.pixelOffset_ = opt_opts.pixelOffset || new google.maps.Size(0, 0); this.position_ = opt_opts.position || new google.maps.LatLng(0, 0); this.zIndex_ = opt_opts.zIndex || null; this.boxStyle_ = opt_opts.boxStyle || {}; this.closeBoxMargin_ = opt_opts.closeBoxMargin || "2px"; this.closeBoxURL_ = opt_opts.closeBoxURL || "http://www.google.com/intl/en_us/mapfiles/close.gif"; if (opt_opts.closeBoxURL === "") { this.closeBoxURL_ = ""; } this.infoBoxClearance_ = opt_opts.infoBoxClearance || new google.maps.Size(1, 1); this.isHidden_ = opt_opts.isHidden || false; this.pane_ = opt_opts.pane || "floatPane"; this.div_ = null; this.closeListener_ = null; this.fixedWidthSet_ = null; } InfoBox.prototype = new google.maps.OverlayView(); InfoBox.prototype.createInfoBoxDiv_ = function () { var bw; if (!this.div_) { this.div_ = document.createElement("div"); this.setBoxStyle_(); this.div_.style.position = "absolute"; this.div_.style.visibility = 'hidden'; if (this.zIndex_ !== null) { this.div_.style.zIndex = this.zIndex_; } this.div_.innerHTML = this.getCloseBoxImg_() + this.content_; this.getPanes()[this.pane_].appendChild(this.div_); this.addClickHandler_(); if (this.div_.style.width) { this.fixedWidthSet_ = true; } else { if (this.maxWidth_ !== 0 && this.div_.offsetWidth > this.maxWidth_) { this.div_.style.width = this.maxWidth_; this.div_.style.overflow = "auto"; this.fixedWidthSet_ = true; } else { bw = this.getBoxWidths_(); this.div_.style.width = (this.div_.offsetWidth - bw.left - bw.right) + "px"; this.fixedWidthSet_ = false; } } this.panBox_(this.disableAutoPan_); google.maps.event.trigger(this, "domready"); } }; InfoBox.prototype.getCloseBoxImg_ = function () { var img = ""; if (this.closeBoxURL_ !== "") { img = "<img"; img += " src='" + this.closeBoxURL_ + "'"; img += " align=right"; img += " style='"; img += " position: relative;"; img += " cursor: pointer;"; img += " margin: " + this.closeBoxMargin_ + ";"; img += "'>"; } return img; }; InfoBox.prototype.addClickHandler_ = function () { var closeBox; if (this.closeBoxURL_ !== "") { closeBox = this.div_.firstChild; this.closeListener_ = google.maps.event.addDomListener(closeBox, 'click', this.getCloseClickHandler_()); } else { this.closeListener_ = null; } }; InfoBox.prototype.getCloseClickHandler_ = function () { var me = this; return function () { me.close(); google.maps.event.trigger(me, "closeclick"); }; }; InfoBox.prototype.panBox_ = function (disablePan) { if (!disablePan) { var map = this.getMap(); var bounds = map.getBounds(); var mapDiv = map.getDiv(); var mapWidth = mapDiv.offsetWidth; var mapHeight = mapDiv.offsetHeight; var boundsSpan = bounds.toSpan(); var longSpan = boundsSpan.lng(); var latSpan = boundsSpan.lat(); var degPixelX = longSpan / mapWidth; var degPixelY = latSpan / mapHeight; var mapWestLng = bounds.getSouthWest().lng(); var mapEastLng = bounds.getNorthEast().lng(); var mapNorthLat = bounds.getNorthEast().lat(); var mapSouthLat = bounds.getSouthWest().lat(); var position = this.position_; var iwOffsetX = this.pixelOffset_.width; var iwOffsetY = this.pixelOffset_.height; var padX = this.infoBoxClearance_.width; var padY = this.infoBoxClearance_.height; var iwWestLng = position.lng() + (iwOffsetX - padX) * degPixelX; var iwEastLng = position.lng() + (iwOffsetX + this.div_.offsetWidth + padX) * degPixelX; var iwNorthLat = position.lat() - (iwOffsetY - padY) * degPixelY; var iwSouthLat = position.lat() - (iwOffsetY + this.div_.offsetHeight + padY) * degPixelY; var shiftLng = (iwWestLng < mapWestLng ? mapWestLng - iwWestLng : 0) + (iwEastLng > mapEastLng ? mapEastLng - iwEastLng : 0); var shiftLat = (iwNorthLat > mapNorthLat ? mapNorthLat - iwNorthLat : 0) + (iwSouthLat < mapSouthLat ? mapSouthLat - iwSouthLat : 0); if (!(shiftLat === 0 && shiftLng === 0)) { var c = map.getCenter(); map.setCenter(new google.maps.LatLng(c.lat() - shiftLat, c.lng() - shiftLng)); } } }; InfoBox.prototype.setBoxStyle_ = function () { var i; var boxStyle = this.boxStyle_; for (i in boxStyle) { if (boxStyle.hasOwnProperty(i)) { this.div_.style[i] = boxStyle[i]; } } if (typeof this.div_.style.opacity !== "undefined") { this.div_.style.filter = "alpha(opacity=" + (this.div_.style.opacity * 100) + ")"; } }; InfoBox.prototype.getBoxWidths_ = function () { var computedStyle; var bw = { top: 0, bottom: 0, left: 0, right: 0 }; var box = this.div_; if (document.defaultView && document.defaultView.getComputedStyle) { computedStyle = box.ownerDocument.defaultView.getComputedStyle(box, ""); if (computedStyle) { bw.top = parseInt(computedStyle.borderTopWidth, 10) || 0; bw.bottom = parseInt(computedStyle.borderBottomWidth, 10) || 0; bw.left = parseInt(computedStyle.borderLeftWidth, 10) || 0; bw.right = parseInt(computedStyle.borderRightWidth, 10) || 0; } } else if (document.documentElement.currentStyle) { if (box.currentStyle) { bw.top = parseInt(box.currentStyle.borderTopWidth, 10) || 0; bw.bottom = parseInt(box.currentStyle.borderBottomWidth, 10) || 0; bw.left = parseInt(box.currentStyle.borderLeftWidth, 10) || 0; bw.right = parseInt(box.currentStyle.borderRightWidth, 10) || 0; } } return bw; }; InfoBox.prototype.onRemove = function () { if (this.div_) { this.div_.parentNode.removeChild(this.div_); this.div_ = null; } }; InfoBox.prototype.draw = function () { this.createInfoBoxDiv_(); var pixPosition = this.getProjection().fromLatLngToDivPixel(this.position_); this.div_.style.left = (pixPosition.x + this.pixelOffset_.width) + "px"; this.div_.style.top = (pixPosition.y + this.pixelOffset_.height) + "px"; if (this.isHidden_) { this.div_.style.visibility = 'hidden'; } else { this.div_.style.visibility = "visible"; } }; InfoBox.prototype.setOptions = function (opt_opts) { if (typeof opt_opts.boxStyle !== "undefined") { this.boxStyle_ = opt_opts.boxStyle; this.setBoxStyle_(); } if (typeof opt_opts.content !== "undefined") { this.setContent(opt_opts.content); } if (typeof opt_opts.disableAutoPan !== "undefined") { this.disableAutoPan_ = opt_opts.disableAutoPan; } if (typeof opt_opts.maxWidth !== "undefined") { this.maxWidth_ = opt_opts.maxWidth; } if (typeof opt_opts.pixelOffset !== "undefined") { this.pixelOffset_ = opt_opts.pixelOffset; } if (typeof opt_opts.position !== "undefined") { this.setPosition(opt_opts.position); } if (typeof opt_opts.zIndex !== "undefined") { this.setZIndex(opt_opts.zIndex); } if (typeof opt_opts.closeBoxMargin !== "undefined") { this.closeBoxMargin_ = opt_opts.closeBoxMargin; } if (typeof opt_opts.closeBoxURL !== "undefined") { this.closeBoxURL_ = opt_opts.closeBoxURL; } if (typeof opt_opts.infoBoxClearance !== "undefined") { this.infoBoxClearance_ = opt_opts.infoBoxClearance; } if (typeof opt_opts.isHidden !== "undefined") { this.isHidden_ = opt_opts.isHidden; } if (this.div_) { this.draw(); } }; InfoBox.prototype.setContent = function (content) { this.content_ = content; if (this.div_) { if (this.closeListener_) { google.maps.event.removeListener(this.closeListener_); this.closeListener_ = null; } if (!this.fixedWidthSet_) { this.div_.style.width = ""; } this.div_.innerHTML = this.getCloseBoxImg_() + content; if (!this.fixedWidthSet_) { this.div_.style.width = this.div_.offsetWidth + "px"; this.div_.innerHTML = this.getCloseBoxImg_() + content; } this.addClickHandler_(); } google.maps.event.trigger(this, "content_changed"); }; InfoBox.prototype.setPosition = function (latlng) { this.position_ = latlng; if (this.div_) { this.draw(); } google.maps.event.trigger(this, "position_changed"); }; InfoBox.prototype.setZIndex = function (index) { this.zIndex_ = index; if (this.div_) { this.div_.style.zIndex = index; } google.maps.event.trigger(this, "zindex_changed"); }; InfoBox.prototype.getContent = function () { return this.content_; }; InfoBox.prototype.getPosition = function () { return this.position_; }; InfoBox.prototype.getZIndex = function () { return this.zIndex_; }; InfoBox.prototype.show = function () { this.isHidden_ = false; this.div_.style.visibility = "visible"; }; InfoBox.prototype.hide = function () { this.isHidden_ = true; this.div_.style.visibility = "hidden"; }; InfoBox.prototype.open = function (map, anchor) { if (anchor) { this.position_ = anchor.getPosition(); } this.setMap(map); if (this.div_) { this.panBox_(); } }; InfoBox.prototype.close = function () { if (this.closeListener_) { google.maps.event.removeListener(this.closeListener_); this.closeListener_ = null; } this.setMap(null); };;

		var map, route_collection = [], marker_image, marker_image_consolidate, infowindows = [];

		initialize();

		function initialize() {
			if (!document.getElementById('routes-map')) return;

			console.log('Init route map')

			marker_image = {
				url: '../build/images/marker-sm.png',
				size: new google.maps.Size(10, 10),
				origin: new google.maps.Point(0, 0),
				anchor: new google.maps.Point(5, 5)
			};

			marker_image_consolidate = {
				url: '../build/images/marker-sm-c.png',
				size: new google.maps.Size(10, 10),
				origin: new google.maps.Point(0, 0),
				anchor: new google.maps.Point(5, 5)
			};

			var mapOptions = {
				zoom: 3,
				center: new google.maps.LatLng(29.508741037823192, 76.31148803493753),
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				scrollwheel: false,
				mapTypeControlOptions: {
					mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'routeMap']
				}
			};

			var style = [
				{
					featureType: "all",
					elementType: "labels.text.fill",
					stylers: [
						{ "visibility": "off" },
						{ "color": "#eeeeee" }
					]
				},
				{
					featureType: "all",
					elementType: "labels.icon",
					stylers: [
						{ "visibility": "on" },
						{ "color": "#ffffff" }
					]
				}
			];

			map = new google.maps.Map(document.getElementById('routes-map'), mapOptions);

			var mapType = new google.maps.StyledMapType(style, {
				name: "Карта"
			});

			map.mapTypes.set('routeMap', mapType);
			map.setMapTypeId('routeMap');

			var targ = getCookie("switcher-route");
			if (targ !== undefined) {
				show_route(targ);
				deleteCookie("switcher-route");
			}
			else {
				var default_route = addressActive.attr('data-route');

				$.getJSON(default_route).done(function(route) {
					show_route(route)
				});
			}

			address.on('click', function() {
				var item = $(this);

				item.siblings('.m-active').removeClass('m-active');
				item.addClass('m-active');

				$.getJSON(item.data('route')).done(function(route) {
					show_route(route)
				});
			});
		}



		function show_route(route) {
			if (!document.getElementById('routes-map')) return;
			if (route == undefined) {
				jQuery('#routes-map').hide();
				return;
			}

			if (route_collection) {
				for (var s in route_collection)
					route_collection[s].setMap(null);

				for (var s in infowindows)
					infowindows[s].close();
			}

			var coords;

			for (var j in route.segments) {

				coords = [];
				if (route.segments[j].coordinates.length > 2) {
					coords = getInterpolatedPoly(route.segments[j].coordinates);
				} else coords = route.segments[j].coordinates;

				var route_color = route.color;
				if (route.segments[j].color) {
					route_color = route.segments[j].color;
				}

				var path = [];
				for (var k in coords) {
					path.push(new google.maps.LatLng(coords[k][0], coords[k][1]));
				}
				var lineSymbol = {
					path: google.maps.SymbolPath.FORWARD_OPEN_ARROW,
				};
				route_collection.push(new google.maps.Polyline({
					path: path,
					strokeColor: route_color,
					strokeOpacity: 1.0,
					strokeWeight: 2,
					icons: [
						{
							icon: lineSymbol,
							offset: '20px',
							repeat: '50px'
						}
					]
				}));

				route_collection[route_collection.length - 1].setMap(map);


				if (route.segments[j].start_city) {
					var icon;
					if (route.segments[j].type == "consolidation") {
						icon = marker_image_consolidate;
					} else {
						icon = marker_image;
					}
					route_collection.push(new google.maps.Marker({
						position: new google.maps.LatLng(route.segments[j].coordinates[0][0], route.segments[j].coordinates[0][1]),
						map: map,
						icon: icon,
						title: route.segments[j].start_city
					}));
					route_collection[route_collection.length - 1].setMap(map);

					var label_offset_x = 0, label_offset_y = 0;
					if (route.segments[j].label_offset) {
						label_offset_x = route.segments[j].label_offset[0];
						label_offset_y = route.segments[j].label_offset[1];
					}
					infowindows.push(new InfoBox({
						content: route.segments[j].start_city,
						disableAutoPan: false,
						pixelOffset: new google.maps.Size(label_offset_x, label_offset_y),
						zIndex: null,
						boxStyle: {
							background: "none"
						},
						closeBoxURL: "",
						disableAutoPan: true,
						infoBoxClearance: new google.maps.Size(1, 1)
					}));
					infowindows[infowindows.length - 1].open(map, route_collection[route_collection.length - 1]);

					google.maps.event.addListener(route_collection[route_collection.length - 1], 'click', function () {

						infowindow[this.index].open(map, this);
					});

				}
				if (route.segments[j].end_city) {
					route_collection.push(new google.maps.Marker({
						position: new google.maps.LatLng(route.segments[j].coordinates[route.segments[j].coordinates.length - 1][0], route.segments[j].coordinates[route.segments[j].coordinates.length - 1][1]),
						map: map,
						icon: marker_image,
						title: route.segments[j].end_city
					}));
					route_collection[route_collection.length - 1].setMap(map);

					infowindows.push(new InfoBox({
						content: route.segments[j].end_city,
						disableAutoPan: false,
						pixelOffset: new google.maps.Size(-21, -18),
						zIndex: null,
						boxStyle: {
							background: "none"
						},
						closeBoxURL: "",
						disableAutoPan: true,
						infoBoxClearance: new google.maps.Size(1, 1)
					}));
					infowindows[infowindows.length - 1].open(map, route_collection[route_collection.length - 1]);

					google.maps.event.addListener(route_collection[route_collection.length - 1], 'click', function () {

						infowindow[this.index].open(map, this);
					});
				}
			}
			map.setCenter(new google.maps.LatLng(route.center[0], route.center[1]));
			
			breakpoint('xs', 'md')
				.onmatch(function(){
					var deltaZoom = 1;
					var responsiveZoom = route.zoom - deltaZoom;
					var calcZoom = responsiveZoom >= 1 ? route.zoom - deltaZoom : route.zoom;

					map.setZoom(calcZoom);
				})
				.onmismatch(function(){
					map.setZoom(route.zoom);
				});
		}

		function get_coord(v0, v1, v2, t) {
			var c = (1 - t) * (1 - t) * v0 + 2 * t * (1 - t) * v1 + t * t * v2;
			return c;
		}

		function calcNaturalCubic(n, x) {
			var gamma = [];
			var delta = [];
			var D = [];
			var i = 0;

			gamma[0] = 1.0 / 2.0;
			for (var i = 1; i < n; i++) {
				gamma[i] = 1 / (4 - gamma[i - 1]);
			}
			gamma[n] = 1 / (2 - gamma[n - 1]);

			delta[0] = 3 * (x[1] - x[0]) * gamma[0];
			for (var i = 1; i < n; i++) {
				delta[i] = (3 * (x[i + 1] - x[i - 1]) - delta[i - 1]) * gamma[i];
			}
			delta[n] = (3 * (x[n] - x[n - 1]) - delta[n - 1]) * gamma[n];

			D[n] = delta[n];
			for (var i = n - 1; i >= 0; i--) {
				D[i] = delta[i] - gamma[i] * D[i + 1];
			}

			var C = [];
			for (var i = 0; i < n; i++) {
				C[i] = {
					"a": x[i],
					"b": D[i],
					"c": 3 * (x[i + 1] - x[i]) - 2 * D[i] - D[i + 1],
					"d": 2 * (x[i] - x[i + 1]) + D[i] + D[i + 1]
				};
			}

			return C;
		}

		function eval_(a, b, c, d, u) {
			return ((d * u + c) * u + b) * u + a;
		}

		function eval_derivative(a, b, c, d, u) {
			return b + u * (2 * c + 3 * d * u);
		}


		function getInterpolatedPoly(points) {
			var i = 0;
			var j = 0;
			var u = 0;


			var ret = [];

			var xpts = [];
			var ypts = [];
			for (var i in points) {
				xpts.push(points[i][0]);
				ypts.push(points[i][1]);
			}

			var xc = calcNaturalCubic(points.length - 1, xpts);
			var yc = calcNaturalCubic(points.length - 1, ypts);

			ret.push([eval_(xc[0].a, xc[0].b, xc[0].c, xc[0].d, 0), eval_(yc[0].a, yc[0].b, yc[0].c, yc[0].d, 0)]);

			var stepsNum = 3;

			for (i = 0; i < xc.length; i++) {
				for (var j = 1; j <= stepsNum; j++) {
					u = j / stepsNum;
					var nx = eval_(xc[i].a, xc[i].b, xc[i].c, xc[i].d, u);
					var ny = eval_(yc[i].a, yc[i].b, yc[i].c, yc[i].d, u);
					ret.push([nx, ny]);
				}
			}

			return ret;
		};
	});
});
